import { useForm, useFormContext } from 'react-hook-form';

import {
  GrasslandGrassType,
  GrasslandOrganicFertilizerType,
  LandQuestionnaireAnswers,
  Plot,
} from '@/api/rest/resources/types/plot';

import { GrasslandInputs, PlotCreationInputs, PlotInputs } from '../types';

export type CustomFormArgs = { previousPath?: string };

export type UploadPlotFormArgs = { draftPlots?: string[] };

export type DrawPlotFormArgs = { plot?: Partial<Plot>; questionnaire?: LandQuestionnaireAnswers<PlotInputs> };

export type useCreatePlotFormArgs = CustomFormArgs & PlotCreationInputs & DrawPlotFormArgs & UploadPlotFormArgs;

export const useCreatePlotForm = ({
  type,
  plot,
  questionnaire,
  draftPlots,
  previousPath,
}: useCreatePlotFormArgs | undefined = {}) => {
  return useForm<PlotInputs>({
    values: {
      type,
      plotType: plot?.type,
      name: plot?.name,
      polygon: plot?.polygon,
      areaSquareMeters: plot?.area,
      crops: plot?.crops,
      draftPlots: draftPlots ?? [],
      ...grasslandQuestionnaireForm(questionnaire),
      custom: {
        previousPath,
      },
    },
  });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
export const grasslandQuestionnaireForm = (questionnaire?: GrasslandInputs) => {
  // TODO: MVP-5319 - BE does not require the questionnaire, hence we hardcode default values
  // Could be removed after more confirmation from BE/Science
  return {
    grassland_biodiversity_livestock_units: 0,
    grassland_converted_to_permanent_in_last_20y: false,
    grassland_grass_type: GrasslandGrassType.PERENNIAL_GRASS,
    grassland_num_of_mechanical_events_per_year: 0,
    grassland_organic_fertilizer_type: GrasslandOrganicFertilizerType.NONE,
    grassland_regularly_exposed_to_backwater: false,
    grassland_subject_to_water_shortages: false,
  };
};

export const usePlotForm = () => {
  return useFormContext<PlotInputs>();
};
